import script from "./CoachIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachIntroduction.vue?vue&type=script&setup=true&lang=js"

import "./CoachIntroduction.vue?vue&type=style&index=0&id=997a6d0e&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-997a6d0e"]])

export default __exports__